import { CertificationStatus } from "@/screens/Companies/edit/components/certification/types"
import { createStatusMap } from "@/utils/statusMap"

export const CertificationStatusMap = createStatusMap<CertificationStatus, "error" | "success" | "info">([
  [CertificationStatus.MORE_THAN, "success"],
  [CertificationStatus.LESS_THAN, "info"],
  [CertificationStatus.EXPIRED, "error"],
])

export const CertificationStatusColorMap = new Map<CertificationStatus, string>([
  [CertificationStatus.EXPIRED, "bg-red-200"],
  [CertificationStatus.LESS_THAN, "bg-tertiary-yellow-500"],
  [CertificationStatus.MORE_THAN, "bg-tertiary-green-500"],
])
